import {
    CONFIRMED_GET_DEFAULT_DOSES,
    CONFIRMED_CREATE_DEFAULT_DOSE,
    CONFIRMED_DELETE_DEFAULT_DOSE,
    CONFIRMED_EDIT_DEFAULT_DOSE,
  } from "../types/DefaultDoseTypes";
  
  const initialState = {
    doses: [],
    num_rows: 0,
  };
  
  export default function DefaultDoseReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_DEFAULT_DOSES:
        return {
          ...state,
          doses: action.payload.doses,
          num_rows: action.payload.num_rows,
        };
  
      case CONFIRMED_CREATE_DEFAULT_DOSE:
        return {
          ...state,
          doses: [...state.doses, action.payload],
        };
  
      case CONFIRMED_DELETE_DEFAULT_DOSE:
        return {
          ...state,
          doses: state.doses.filter(
            (dose) =>
              dose.default_dose_id !== action.payload.default_dose_id
          ),
        };
  
      case CONFIRMED_EDIT_DEFAULT_DOSE:
        const updatedDoses = [...state.doses];
        const index = updatedDoses.findIndex(
          (dose) =>
            dose.default_dose_id === action.payload.default_dose_id
        );
  
        if (index !== -1) {
          updatedDoses[index] = action.payload;
        }
  
        return {
          ...state,
          doses: updatedDoses,
        };
  
      default:
        return state;
    }
  }
  